import { createRoutine } from 'redux-saga-routines';

export const joinMembershipPlanVerifyUserRoutine = createRoutine('join-membership-plan/VERIFY_USER');
export const joinMembershipPlanGetSecretKeyHashRoutine = createRoutine('join-membership-plan/GET_SECRET_KEY_HASH');
export const joinMembershipPlanAuthenticateUserRoutine = createRoutine('join-membership-plan/AUTHENTICATE_USER');
export const joinMembershipPlanGetInvitesRoutine = createRoutine('join-membership-plan/GET_INVITES');
export const joinMembershipPlanAcceptOrDeclineInviteRoutine = createRoutine(
    'join-membership-plan/ACCEPT_OR_DECLINE_INVITE'
);
